import { query } from 'atomic-layout';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin: 112px auto;
  max-width: 1280px;
  background-color: ${props => props.theme.colors.stone[0]};
  flex-direction: column;

  @media ${query({ to: 'sm' })} {
    margin: 60px auto;
  }
`;

export const Title = styled.h1`
  text-align: center;
  margin-bottom: 24px;
  padding: 0px 16px;
`;

export const GridClients = styled.div`
  display: flex;
  margin: 24px auto 12px;
  flex-wrap: wrap;
  max-width: 990px;
  padding: 0px 10px;
  justify-content: center;
`;

export const Client = styled.div`
  display: flex;
  margin: 12px 25px;
  align-items: center;
  justify-content: center;

  @media ${query({ to: 'sm' })} {
    margin: 12px 40px;
  }
`;
